<template>
    <div class="maside">
        <template v-for="item in arrlist">
            <el-submenu v-if="item.children" :key="item.id" :index="item.id+''">
                <template slot="title">
                    <i :class="'iconfont '+item.icon"></i>
                    <span class="msg">{{item.name}}</span>
                    <!-- <span class="info">99+</span> -->
                    <span class="info" v-if="item.icon==='icon-chakan'&&(msgnum.cancellationPendingReview+msgnum.dispatchForReview)">{{msgnum.cancellationPendingReview+msgnum.dispatchForReview||""}}</span>
                    <span class="info" v-if="item.icon==='icon-huiyuanguanli'&&msgnum.memberPendingReview">{{msgnum.memberPendingReview}}</span>
                    <span class="info" v-if="item.icon==='icon-cheduiguanli'&&msgnum.fleetToBeReviewed">{{msgnum.fleetToBeReviewed||""}}</span>
                </template>
                <m-aside :arrlist="item.children||{}" :msgnum="msgnum"></m-aside>
            </el-submenu>
            <el-menu-item v-else :key="item.path" :index="item.path" @click="clickMenuItem(item)">
                <i :class="'iconfont '+item.icon"></i>
                <span class="msg">{{item.name}}</span>
                <template>
                    <span class="info" v-if="item.path==='/audit/entercancel'&&msgnum.cancellationPendingReview">{{msgnum.cancellationPendingReview||""}}</span>
                    <span class="info" v-if="item.path==='/audit/auditcar'&&msgnum.dispatchForReview">{{msgnum.dispatchForReview||""}}</span>
                    <span class="info" v-if="item.path==='/member/newaddmember'&&msgnum.memberPendingReview">{{msgnum.memberPendingReview||""}}</span>
                    <span class="info" v-if="item.path==='/motorcade/newaddcheck'&&msgnum.fleetToBeReviewed">{{msgnum.fleetToBeReviewed||""}}</span>
                </template>
            </el-menu-item>
        </template>
    </div>
</template>
<script>
import {antiShake} from "@/plugins/other.js";
import {mapMutations} from "vuex";
export default {
    name:"mAside",
    props:["arrlist","msgnum"],
    methods:{
        ...mapMutations(["addTitleList"]),
        clickMenuItem(item){
           antiShake(_=>{
               this.addTitleList(item);
           },500)
        }
    }
}
</script>
<style scoped>
    .msg{
        margin:0 5%;
        font-size: 100%;
    }
    .info{
        color: #fff;
        background: #FF5926;
        border-radius: 5px;
        font-size: 80%;
        padding:0 2px;
    }
</style>
